<script>
  export let id;
  export let titulo;
  export let tituloAceptar;
  export let tituloCancelar;
  export let aceptarAction;
  export let text;
  export let aceptarSegundaRevision;
  export let version;

  import { dictionary } from "../utils/stores.js";

  let dict;

  const unsubscribe = dictionary.subscribe(value => {
    dict = value;
  });
</script>

<style>
  div.preguntaPropuesta {
    margin-top: 30px;
  }
</style>

<div class="modal" {id} tabindex="-1" role="dialog">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{titulo}</h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <p>{text}</p>
        {#if version === 1}
          <p />
          <div class="preguntaPropuesta">
            <input type="checkbox" bind:checked={aceptarSegundaRevision} />
            <span>{dict['propuestaSegundaRevision']}</span>
          </div>
        {/if}
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" on:click={aceptarAction}>
          {tituloAceptar}
        </button>
        <button type="button" class="btn btn-secondary" data-dismiss="modal">
          {tituloCancelar}
        </button>
      </div>
    </div>
  </div>
</div>
